import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { OnboardingForm } from '@old/features/public/onboarding/onboarding-form';

export function OnboardingPage() {
  return (
    <AuthLayoutComponent>
      <OnboardingForm />
    </AuthLayoutComponent>
  );
}
